import { render } from "./AuditEntryIcon.vue?vue&type=template&id=5bab5514"
import script from "./AuditEntryIcon.vue?vue&type=script&lang=js"
export * from "./AuditEntryIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__